import React, { useEffect } from "react"
import { ErrorMessage } from "./errorMessage"
import { translateText } from "../../../getTranslationsMyProfileUploadDocumentation"
import { recordLinkV2 } from "utilities/tagging"

export const ErrorWillNotBeAttached = ({filesWithErrors, processSelected}) => {
    useEffect(() => {
        recordLinkV2({
            categoriaEvento: `documentos/subida de documentacion/${processSelected}`,
            accionEvento: `subir archivo ${filesWithErrors}/error`,
            categoriaError: `error en subida de documentacion/${processSelected}`,
            descripcionError: "solo se aceptan documentos de menos de 10mb"
        })
    },[filesWithErrors])

    return (
        <ErrorMessage message={translateText("errorFilesAdvise")} />
    )
}
